import React from 'react';

function Story() {
  return (
    <section className="story">
      <div className="container">
        <h2>Who Is TMT Sir?</h2>
        <div className="story-content">
          <p>
            T.M. Theagarajan, known to students as TMT Sir, spent more than five decades as a teacher with
            E.R. Higher Secondary School and then with Sri Akilandeswari Vidyalaya in Tiruchirappalli. His
            classes are not remembered just for the syllabus but for something rarer: he taught students how
            to think.
          </p>
          <p>
            His students are now lawyers, doctors, engineers, teachers, entrepreneurs, in India and around the
            world. Decades later, they still credit him not with what he taught, but with how he taught them
            to learn.
          </p>
          <p>
            What made his approach work, and can it be constructed as a model design? That is the question we
            try to answer.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Story;